import { Link } from "react-router-dom";
import { MapPin, Calendar, Clock, ArrowUpRight } from "lucide-react";
import { GBP } from "@/lib/api";

export function CourseCard({ course }) {
  return (
    <Link
      to={`/courses/${course.slug || course.id}`}
      data-testid={`course-card-${course.id}`}
      className="group flex flex-col border border-[var(--line)] bg-white hover:border-[var(--ink)] transition-colors"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[var(--alt)]">
        <img
          src={course.image}
          alt={course.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-0 left-0 bg-[var(--ink)] text-white text-[11px] font-semibold px-3 py-1.5 tracking-wide">
          {course.category}
        </span>
        {course.places_remaining <= 5 && (
          <span className="absolute top-0 right-0 bg-[var(--accent)] text-white text-[11px] font-semibold px-3 py-1.5">
            {course.places_remaining} places left
          </span>
        )}
      </div>

      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-wide text-[var(--ink-2)] font-semibold mb-2">
          <span>{course.delivery}</span>
          <span className="h-1 w-1 bg-[var(--ink-2)] rounded-full" />
          <span>{course.level}</span>
        </div>
        <h3 className="font-display font-bold text-lg leading-tight mb-2 group-hover:text-[var(--accent)] transition-colors">
          {course.title}
        </h3>
        <p className="text-sm text-[var(--ink-2)] line-clamp-2 mb-4">{course.summary}</p>

        <div className="mt-auto space-y-2 text-xs text-[var(--ink-2)]">
          <div className="flex items-center gap-2"><MapPin size={13} /> {course.location}</div>
          <div className="flex items-center gap-2"><Calendar size={13} /> Starts {course.start_date}</div>
          <div className="flex items-center gap-2"><Clock size={13} /> {course.duration}</div>
        </div>

        <div className="flex items-end justify-between pt-4 mt-4 border-t border-[var(--line)]">
          <div>
            <div className="font-display font-extrabold text-xl">{GBP(course.price)}</div>
            <div className="text-[11px] text-[var(--ink-2)]">Deposit {GBP(course.deposit_amount)}</div>
          </div>
          <span className="grid place-items-center h-9 w-9 bg-[var(--alt)] group-hover:bg-[var(--accent)] group-hover:text-white transition-colors">
            <ArrowUpRight size={18} />
          </span>
        </div>
      </div>
    </Link>
  );
}
